import { useTranslation } from 'next-i18next';

import { Box, Flex, Heading, Separator } from '@chakra-ui/react';

import { OperatorInformation } from '@app/components/molecules/operator-information';
import { accommodationStaticSlice, useAppSelector } from '@app/state';

import { ImportantInfoProps } from './important-info.props';
import { ImportantInfoItem } from './important-info-item';

export const ImportantInfo = ({ ...props }: ImportantInfoProps) => {
    const { t } = useTranslation('accommodation', {
        keyPrefix: 'importantInfo',
    });
    const { checkInStart, checkInEnd, checkOutStart, checkOutEnd } = useAppSelector(
        accommodationStaticSlice.selectors.selectImportantInfoData,
    );
    const { contactPhoneVisible } = useAppSelector(
        accommodationStaticSlice.selectors.selectContactPhoneData,
    );

    if (!(checkInStart || checkInEnd || checkOutStart || checkOutEnd)) return null;

    return (
        <Box {...props}>
            <Separator mb={6} />
            <Heading
                size={'md'}
                mb={{
                    base: 2,
                    md: 6,
                }}
            >
                {t('importantInfoHeader')}
            </Heading>
            <Flex direction={'column'} gap={4}>
                {contactPhoneVisible ? (
                    <ImportantInfoItem name={t('phoneNumber')} showPhoneNumber />
                ) : null}
                {checkInStart || checkInEnd ? (
                    <ImportantInfoItem
                        name={t('checkIn')}
                        fromHour={checkInStart}
                        toHour={checkInEnd}
                    />
                ) : null}
                {checkOutStart || checkOutEnd ? (
                    <ImportantInfoItem
                        name={t('checkOut')}
                        fromHour={checkOutEnd ? checkOutStart : null}
                        toHour={checkOutEnd || checkOutStart}
                    />
                ) : null}
                <ImportantInfoItem name={t('legalInformation')}>
                    <OperatorInformation />
                </ImportantInfoItem>
            </Flex>
        </Box>
    );
};
